import React, { useEffect, useRef, useState } from "react";
import ReactEcharts from "echarts-for-react";
import { ReactComponent as PngIcon } from "../../../../icon/png.svg";
import { ReactComponent as SvgIcon } from "../../../../icon/SVG.svg";
import { ReactComponent as PdfIcon } from "../../../../icon/pdf.svg";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Button } from "antd";
function HeatEchart({ heatmap, ceshi }) {
  const heatRef = useRef();
  // 定义热图的配置项
//   const [options,setOptions]=useState({})
// useEffect(()=>{
//   if(Object.keys("传过来的值")<=0)return
//   //这里写你的Echarts的配置
//   setOptions("你的配置项内容")
// },["你传过来的值"])
  const getOption = () => {
    return {
      tooltip: {
        position: "top",
      },
      animation: false,
      grid: {
        height: "50%",
        y: "10%",
      },
      xAxis: {
        type:"category",
        splitArea: {
          show: true,
        },
        data: heatmap.xAxis,
        axisLabel:{
          rotate:70
        }
       },
      yAxis:{
        type:"category",
        splitArea: {
          show: true,
        },
        data: heatmap.yAxis,
        axisLabel:{
          rotate:45
        }
       },
      visualMap: {
        orient:"horizontal",
        min: heatmap.minValue?heatmap.minValue:"",  // 设置visualMap的最小值为0.5
        max: heatmap.maxValue?heatmap.maxValue:"",   // 设置visualMap的最大值为1.0
        
        precision:1,                            //数据展示的小数精度，默认为0，无小数点
        splitNumber: 5, // 正确拼写
        calculable: true,
        bottom: "15%",
        top:"-15",
        right:"100",
        position: "top",
        align: "center",  // 水平居中
        verticalAlign: "bottom",  // 垂直方向上对齐到底部
    
      },
      series: [
        {
          name: "Punch Card",
          type: "heatmap",
          data: heatmap.data,
          
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
  };
  /**
 * 处理下载 PDF 文件
 *
 * @returns 无返回值，该函数会触发 PDF 文件的下载
 */

  const handleDownloadPdf = () => {
    const chartInstance = heatRef.current.getEchartsInstance();

    // 获取 echarts 图表容器的 DOM 元素
    const chartContainer = chartInstance.getDom();

    // 使用 html2canvas 将 echarts 图表转换为 Canvas
    html2canvas(chartContainer).then((canvas) => {
      const imageData = canvas.toDataURL("image/png");

      // 获取图表的宽度和高度
      const width = canvas.width * 0.75; // 0.75 是一个调整比例，可以根据需要调整
      const height = canvas.height * 0.75;

      // 创建 PDF 对象
      const pdf = new jsPDF("landscape", "px", [width, height]);

      // 将 Canvas 添加到 PDF 中
      pdf.addImage(imageData, "PNG", 0, 0, width, height);

      // 下载 PDF 文件
      pdf.save("HeatMap.pdf");
    });
  };
  
  /**
 * 处理下载PNG图片的功能
 *
 * @returns 无返回值，执行后将会下载指定的热力图为PNG格式的图片
 */
  const handleDownloadPng = () => {
    const chartInstance = heatRef.current.getEchartsInstance();
    const base64Data = chartInstance.getConnectedDataURL({
      type: "png", // 你想要下载的图片格式，可以是 'png' 或者 'svg'
      backgroundColor: "#fff", // 图表背景色
      pixelRatio: 2, // 像素比例，默认为 1
    });

    // 创建一个虚拟链接并模拟点击以下载文件
    const link = document.createElement("a");
    link.href = base64Data;
    link.download = "HeatMap.png"; // 下载文件的名称
    link.click();
  };



  return (
    <div style={{ display: "flex", flexDirection: "column",width:"100%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          marginRight: "140px",
        }}
      >
        <Button
          style={{
            padding: "20px 10px",
            margin: "10px 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "none",
          }}
          onClick={handleDownloadPng}
        >
          <PngIcon width={30} />
        </Button>
        {/* <Button
          style={{
            padding: "20px 10px",
            margin: "10px 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border:"none"

          }}
        >
          <SvgIcon width={30} />
        </Button> */}
        <Button
          style={{
            padding: "20px 10px",
            margin: "10px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "none",
          }}
          onClick={handleDownloadPdf}
        >
          <PdfIcon width={30} />
        </Button>
      </div>
      <ReactEcharts
        ref={heatRef}
        style={{height: 500 }}
        option={getOption()}
      />
      <p style={{width:"100%",textAlign:"center",marginTop:"-70px",fontWeight:"bold"}}>Normalized Log2(value+1)</p>
    </div>
  );
}

export default HeatEchart;




